import React from "react";
import "./Services.css";
import { Contact, Header, Hire } from "./Components";

const CDRWriting = () => {
  return (
    <div className="servicesPages">
      <Header
        header="Professional CDR Writing Service for Engineering Applicants"
        desc="Get a professionally crafted CDR report with our expert writers to ensure a successful assessment by Engineers Australia. We promise a genuine, tailored CDR to help you achieve your engineering career aspirations"
      />
      <div className="body">
        <div>
          <div className="header">Professional CDR Writing Services for Engineers Australia</div>
          <div className="desc">
            CDR Report Hub offers premium Competency Demonstration Report (CDR) writing services with a high success rate for approval by Engineers Australia (EA). Engineers
            seeking skilled migration to Australia must submit a well-prepared CDR for assessment by Engineers Australia.
          </div>
          <div className="desc">
            Our comprehensive CDR writing services include the preparation of a detailed Curriculum Vitae (CV), three structured Career Episodes (CEs), a tailored Summary Statement
            (SS) for the career episodes, and a Continuing Professional Development (CPD) document. Each report is crafted to highlight your skills, knowledge, work experience,
            academic qualifications, and achievements while adhering to the official guidelines set by Engineers Australia to ensure a positive outcome.
          </div>
          <div className="desc">
            We recognize the challenges involved in preparing a CDR and aim to simplify the process for you. Our expert team is dedicated to delivering a high-quality, professional
            CDR report that meets all requirements and standards.
          </div>
          <div className="desc">
            At CDR Report Hub, our experienced engineering professionals are committed to helping you achieve a 100% approval rate from Engineers Australia. Our reports are
            original, plagiarism-free, and carefully written to showcase your expertise. In addition to CDR writing, we provide services such as CDR reviewing, resume writing, RPL
            (Recognition of Prior Learning) writing, and plagiarism checking and removal.
          </div>
          <div className="header">What is CDR (Competency Demonstration Report) and why it is required ?</div>
          <div className="desc">
            Competency Demonstration Report (CDR), a technical report required by Engineers Australia from applicants who aim to make a career in engineering in Australia.
            Australia is utilizing CDR Reports as an appraisal method for evaluating the competency and education level of overseas Engineering students and professionals who
            desire to work in Australia. The primary rationale of CDR is a demonstration of your skills and knowledge at a professional level as either an engineering associate,
            professional engineer, or engineering technologist.
          </div>
          <div className="desc">
            The following are critical points to remember to prepare a CDR report that is 100% successful. Technical engineering applications and demonstration of that knowledge in
            the selected occupation are needed for the applicants. The ANZSCO society and graduate competency standards will be used to evaluate your report.
          </div>
        </div>
      </div>
      <Contact />
      <Hire />
    </div>
  );
};

export default CDRWriting;
